// The AccountHeaderItem model defines the structure of the items in the Boa header.
import { z } from 'zod';

// Define the Zod schema for AccountHeaderItemType
export const AccountHeaderItemSchema = z.union([
  z.object({
    name: z.literal('Waste Profiles'),
    url: z.literal('profiling'),
    svgIcon: z.literal('waste-profile-pillar'),
    svgIconHover: z.literal('waste-profile-pillar-hover'),
    selected: z.boolean(),
  }),
  z.object({
    name: z.literal('Reports'),
    url: z.literal('reporting'),
    svgIcon: z.literal('reporting-pillar'),
    svgIconHover: z.literal('reporting-pillar-hover'),
    selected: z.boolean(),
  }),
]);

// Define the TypeScript type from the Zod schema
export type AccountHeaderItemType = z.infer<typeof AccountHeaderItemSchema>;

export const ACCOUNT_HEADER_ITEMS: AccountHeaderItemType[] = [
  {
    name: 'Waste Profiles',
    url: 'profiling',
    svgIcon: 'waste-profile-pillar',
    svgIconHover: 'waste-profile-pillar-hover',
    selected: false,
  },
  {
    name: 'Reports',
    url: 'reporting',
    svgIcon: 'reporting-pillar',
    svgIconHover: 'reporting-pillar-hover',
    selected: false,
  },
];
